var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.913 12.7826H0.782609C0.350607 12.7826 0 12.432 0 12C0 11.568 0.350607 11.2174 0.782609 11.2174H15.913C16.345 11.2174 16.6956 11.568 16.6956 12C16.6956 12.432 16.345 12.7826 15.913 12.7826Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7391 16.9565C11.5387 16.9565 11.3384 16.8805 11.1859 16.7271C10.8802 16.4213 10.8802 15.9257 11.1859 15.6198L14.8068 11.9991L11.1859 8.3782C10.8802 8.07249 10.8802 7.57667 11.1859 7.27097C11.4918 6.96526 11.9875 6.96526 12.2932 7.27097L16.467 11.445C16.7727 11.7507 16.7727 12.2463 16.467 12.5521L12.2932 16.7259C12.1397 16.8805 11.9395 16.9565 11.7391 16.9565Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5217 23.4783C7.77278 23.4783 3.5802 20.6213 1.83863 16.1989C1.68004 15.7982 1.87818 15.3433 2.27999 15.1847C2.68066 15.0282 3.13673 15.2233 3.29532 15.6272C4.79902 19.4453 8.42088 21.9131 12.5217 21.9131C17.9874 21.9131 22.4349 17.4656 22.4349 12C22.4349 6.53434 17.9874 2.08688 12.5217 2.08688C8.42088 2.08688 4.79902 4.5547 3.29532 8.37278C3.13559 8.7767 2.68066 8.97178 2.27999 8.8153C1.87818 8.65671 1.68004 8.20178 1.83863 7.80111C3.5802 3.37869 7.77278 0.521667 12.5217 0.521667C18.8505 0.521667 24.0001 5.67129 24.0001 12C24.0001 18.3287 18.8505 23.4783 12.5217 23.4783Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressure);
export default __webpack_public_path__ + "static/media/pressure.bd47cdd64a9e2de66740e282b0c00f04.svg";
export { ForwardRef as ReactComponent };